module.exports = __webpack_public_path__ + "img/1F917.897749c9.svg";